import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
var _templateObject;
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React from "react";
import { makeStyles, Typography, RaiseColors, Icon } from "client/componentLibrary";
import classNames from "classnames";
import { gql } from "@apollo/client";
import { useMiniBuildingCardQuery } from "raise-types";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    cardContainer: {
      position: "relative",
      display: "flex",
      height: 104,
      width: 344,
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
      borderRadius: 4,
      backgroundColor: RaiseColors.white,
      border: "1px solid ".concat(RaiseColors.gray100),
      zIndex: 1000
    },
    buildingPicContainer: {
      width: 113,
      backgroundColor: RaiseColors.gray100,
      cursor: "pointer",
      "& img": {
        height: "100%",
        width: "100%",
        borderRadius: "4px 0px 0px 4px",
        display: "block"
      }
    },
    cityIcon: {
      paddingTop: 40,
      paddingLeft: 40
    },
    body: {
      margin: "8px 10px 8px 16px",
      maxWidth: 190,
      "&:hover": {
        cursor: "pointer"
      }
    },
    titleText: {
      display: "flex"
    },
    subtext: {
      display: "flex",
      margin: "0px 0px 10px"
    },
    neighborhoodText: {
      display: "flex",
      margin: "0px 0px 4px"
    }
  };
});
gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query MiniBuildingCardQuery($buildingId: UUID!) {\n        building(id: $buildingId) {\n            id\n            location {\n                id\n                displayMarketLabel\n                displaySubmarketLabel\n            }\n            buildingImages {\n                id\n                url\n            }\n            primaryAddress {\n                id\n                fullAddress\n                city\n                state\n                postalCode\n            }\n        }\n    }\n"])));
var MiniBuildingCard = function MiniBuildingCard(_ref) {
  var _building$location, _building$buildingIma, _building$buildingIma2;
  var buildingId = _ref.buildingId,
    onCardClick = _ref.onCardClick;
  var _useMiniBuildingCardQ = useMiniBuildingCardQuery({
      variables: {
        buildingId: buildingId
      }
    }),
    data = _useMiniBuildingCardQ.data,
    loading = _useMiniBuildingCardQ.loading,
    error = _useMiniBuildingCardQ.error;
  if (loading || error) {
    return null;
  }
  var building = data === null || data === void 0 ? void 0 : data.building;
  var _building$primaryAddr = building === null || building === void 0 ? void 0 : building.primaryAddress,
    city = _building$primaryAddr.city,
    state = _building$primaryAddr.state,
    postalCode = _building$primaryAddr.postalCode,
    fullAddress = _building$primaryAddr.fullAddress;
  return /*#__PURE__*/_jsx(MiniBuildingCardInnerContent, {
    onCardClick: onCardClick,
    city: city,
    state: state,
    zip: postalCode,
    streetAddress: fullAddress,
    neighborhood: building === null || building === void 0 || (_building$location = building.location) === null || _building$location === void 0 ? void 0 : _building$location.displaySubmarketLabel,
    buildingImgUrl: (_building$buildingIma = building === null || building === void 0 || (_building$buildingIma2 = building.buildingImages[0]) === null || _building$buildingIma2 === void 0 ? void 0 : _building$buildingIma2.url) !== null && _building$buildingIma !== void 0 ? _building$buildingIma : ""
  });
};
var MiniBuildingCardInnerContent = function MiniBuildingCardInnerContent(_ref2) {
  var _context, _context2;
  var buildingImgUrl = _ref2.buildingImgUrl,
    streetAddress = _ref2.streetAddress,
    city = _ref2.city,
    state = _ref2.state,
    zip = _ref2.zip,
    neighborhood = _ref2.neighborhood,
    onCardClick = _ref2.onCardClick;
  var classes = useStyles();
  var ifStreetAddress = streetAddress;
  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: classes.cardContainer,
    "data-testid": "mini-building-card-container",
    onClick: onCardClick,
    children: [/*#__PURE__*/_jsx("div", {
      className: classes.buildingPicContainer,
      children: buildingImgUrl ? /*#__PURE__*/_jsx("img", {
        src: buildingImgUrl,
        "data-testId": "miniBuildingImgUrl"
      }) : /*#__PURE__*/_jsx(Icon, {
        className: classNames("far fa-city", classes.cityIcon),
        color: RaiseColors.black
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.body,
      "data-testid": "mini-building-card-link",
      children: [/*#__PURE__*/_jsx("div", {
        className: classes.titleText,
        children: /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          variant: "paragraph_small",
          weight: "semibold",
          color: RaiseColors.black,
          children: ifStreetAddress ? toTitleCase(streetAddress) : null
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classes.subtext,
        children: /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          weight: "regular",
          variant: "paragraph_small",
          color: RaiseColors.black,
          children: _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(city, ", ")).call(_context2, state, " ")).call(_context, zip)
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classes.neighborhoodText,
        children: /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          color: RaiseColors.gray300,
          variant: "paragraph_xsmall",
          children: neighborhood
        })
      })]
    })]
  });
};
export { MiniBuildingCardInnerContent };
export default MiniBuildingCard;